var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0058A3",
  fillRule: "evenodd",
  d: "M19.02 9.03a1 1 0 0 0-1 1 8 8 0 1 1-2.24-5.55 1.001 1.001 0 1 0 1.42-1.41A9.9 9.9 0 0 0 10 0a10 10 0 1 0 10 10 1 1 0 0 0-.98-.97m-9-3.91a1.23 1.23 0 1 0 1.22 1.22 1.22 1.22 0 0 0-1.22-1.22m-1 4.02h2v5.97h-2z",
  clipRule: "evenodd"
})));
export default SvgInfoIcon;